import { Injectable } from '@angular/core';
import { ScopesService } from '../scopes.service';

import { Scopes } from '../../models/scope.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScopesResolver {
  constructor(
    private _scopesService: ScopesService,
  ) {}

  public resolve(): Observable<Scopes> {
    return this._scopesService.getScopes();
  }
}
